import { ICurrency, ICurrencyData } from '../currency.types';
import { Currency } from '../currency';

export const mockCurrenciesData = (): ICurrencyData[] => [
  {
    id: 1,
    code: 'CAD',
    description: 'Canadian Dollar'
  },
  {
    id: 2,
    code: 'USD',
    description: 'US Dollar'
  }
];

export const mockCurrencies = (
  data: ICurrencyData[] = mockCurrenciesData()
): ICurrency[] => data.map(item => new Currency(item));
